@use "sass:color";
@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.schoolsPageContainer {
  padding: variables.$std-padding-sm;
}

.newSchoolContainer {
  background-color: color.adjust(#8bc34a, $lightness: 20%);
  font-weight: bold;
  color: color.adjust(#8bc34a, $lightness: -20%);
  padding: variables.$std-padding-md;
  margin-bottom: variables.$std-margin-sm;
}
